(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["coupons"] && !window.DesignMode) return;
  try {
    
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    }); 
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mygallery"] && !window.DesignMode) return;
  try {
    
$(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
}); 

  } catch(e) { console.error(e); }
})();

})();
